<template>
    <div>
        <h1>
            Overview
        </h1>
       
        <server-stats></server-stats>
        <server-list></server-list>
    </div>
</template>

<script>
    import Vue from 'vue'
    import ServerList from './server-list'
    import ServerStats from './server-stats'
    import ConnectionsGraph from './connections-graph'

    Vue.component('server-list', ServerList);
    Vue.component('server-stats', ServerStats);
    Vue.component('connections-graph', ConnectionsGraph)

    export default {
        props: {
        },
        data () {
            return {
            }
        },
        computed: {
            
        },
        watch: {
            
        },
        methods: {

            skConsoleNumberToHtmlColour: function (number) {
                switch (number) {
                    case 9: return '#428bca';
                    case 14: return '#f0ad4e';
                    case 8: return '#999999';
                    case 12: return '#d9534f';
                    case 2: return '#5cb85c';
                    case 7: return '#cccccc';
                    default: return '#ffffff';
                }
            },
        }
    }
</script>

<style>

</style>
